import { AxiosRequestConfig } from 'axios';
import {
  BaseModel,
  BooleanApiResponse,
  DeviceAppRegistrationDto,
  DeviceDto,
  DeviceModel,
  DeviceRegistrationWithProductDto,
  GetProductQueryParams,
  GetDeviceQueryParams,
  GetDeviceRegistrationWithProductQueryParams,
  GetPlatformQueryParams,
  PlatformDto,
  ProductDto,
  GetServiceUserServiceUserViewQueryParams,
  ServiceUserViewDto,
  GetDeviceAppRegistrationQueryParams,
  BaseModelBulkItemModel,
  DeviceAppRegistrationDtoApiResponseListApiResponse
} from 'src/models/devicemanagement';
import { GetAxiosInstance } from '../baseService';
import { ServiceLocation } from '../serviceLocationsAxios';

export const getDevice = (id: string) => {
  return GetAxiosInstance().get<DeviceDto>(`${ServiceLocation.deviceManagement}/Device/${id}`);
};

/**
 * Get Devices
 *
 * @param params GetDeviceQueryParams
 * @returns DeviceDto[]
 */
export const getDevices = (params?: GetDeviceQueryParams) => {
  return GetAxiosInstance().get<DeviceDto[]>(`${ServiceLocation.deviceManagement}/Device`, { params });
};

/**
 * Get Device App Registrations
 *
 * @param params GetDeviceAppRegistrationQueryParams
 * @returns DeviceAppRegistrationDto[]
 */
export const getDeviceAppRegistrations = (params?: GetDeviceAppRegistrationQueryParams) => {
  return GetAxiosInstance().get<DeviceAppRegistrationDto[]>(
    `${ServiceLocation.deviceManagement}/DeviceAppRegistration`,
    { params }
  );
};

/**
 * Delete Device App Registration by Id
 * @param id Id of the device app registration
 * @param model BaseModel
 * @returns BooleanApiResponse
 */
export const deleteDeviceAppRegistrationById = (id: string, model: BaseModel) => {
  const reqBody: AxiosRequestConfig<BaseModel> = {
    data: model
  };

  return GetAxiosInstance().delete<BooleanApiResponse>(
    ServiceLocation.deviceManagement + '/DeviceAppRegistration/' + id,
    reqBody
  );
};

/**
 * Bulk Delete Device App Registrations
 * @param data BaseModelBulkItemModel[]
 * @returns DeviceAppRegistrationDtoApiResponseListApiResponse
 */
export const bulkDeleteDeviceAppRegistrations = (data: BaseModelBulkItemModel[]) => {
  const reqBody: AxiosRequestConfig<BaseModelBulkItemModel[]> = {
    data
  };

  return GetAxiosInstance().delete<DeviceAppRegistrationDtoApiResponseListApiResponse>(
    ServiceLocation.deviceManagement + '/DeviceAppRegistration',
    reqBody
  );
};

/**
 * Get Platforms
 *
 * @param params GetPlatformQueryParams
 * @returns PlatformDto[]
 */
export const getPlatforms = (params?: GetPlatformQueryParams) => {
  return GetAxiosInstance().get<PlatformDto[]>(`${ServiceLocation.deviceManagement}/Platform`, { params });
};

/**
 * Get Service User View
 *
 * @param params GetServiceUserServiceUserViewQueryParams
 * @returns ServiceUserViewDto[]
 */
export const getServiceUserView = (params: GetServiceUserServiceUserViewQueryParams) => {
  return GetAxiosInstance().get<ServiceUserViewDto[]>(
    `${ServiceLocation.deviceManagement}/ServiceUser/ServiceUserView`,
    { params }
  );
};

/**
 * Get Products
 *
 * @param params GetProductQueryParams
 * @returns ProductDto[]
 */
export const getProducts = (params?: GetProductQueryParams) => {
  return GetAxiosInstance().get<ProductDto[]>(`${ServiceLocation.deviceManagement}/Product`, { params });
};

/**
 * Delete Device
 *
 * @params {id: string; data: AxiosRequestConfig<{ remarks: string; version: string }>;
 */
export const deleteDevice = (params: {
  id: string;
  data: AxiosRequestConfig<{ remarks: string; version: string }>;
}) => {
  return GetAxiosInstance().delete(`${ServiceLocation.deviceManagement}/Device/${params.id}`, params.data);
};

export const deleteDevices = (data: BaseModelBulkItemModel[]) => {
  return GetAxiosInstance().delete<BooleanApiResponse>(`${ServiceLocation.deviceManagement}/Device`, { data });
};

/**
 * Put Device
 *
 * @param id Id of the device
 * @param model DeviceModel
 * @returns
 */
export const putDeviceById = (id: string, model: DeviceModel) => {
  return GetAxiosInstance().put(`${ServiceLocation.deviceManagement}/Device/${id}`, model);
};

/**
 * Get Device Registration With Products
 * @param params GetDeviceRegistrationWithProductQueryParams
 * @returns DeviceRegistrationWithProductDto[]
 */
export const getDeviceRegistrationWithProducts = (params?: GetDeviceRegistrationWithProductQueryParams) => {
  return GetAxiosInstance().get<DeviceRegistrationWithProductDto[]>(
    ServiceLocation.deviceManagement + '/DeviceRegistrationWithProduct',
    { params }
  );
};

export const deleteDeviceById = (id: string, model: BaseModel) => {
  const reqBody: AxiosRequestConfig<BaseModel> = {
    data: model
  };

  return GetAxiosInstance().delete<BooleanApiResponse>(ServiceLocation.deviceManagement + '/Device/' + id, reqBody);
};
